export const WORKFLOWS_FETCH_START = 'WORKFLOWS_FETCH_START';
export const WORKFLOWS_FETCH_API = 'WORKFLOWS_FETCH_API';
export const WORKFLOWS_FETCH_API_PENDING = 'WORKFLOWS_FETCH_API_PENDING';
export const WORKFLOWS_FETCH_API_FULFILLED = 'WORKFLOWS_FETCH_API_FULFILLED';
export const WORKFLOWS_FETCH_API_REJECTED = 'WORKFLOWS_FETCH_API_REJECTED';
export const WORKFLOWS_FETCH_PAYLOAD_INJECT = 'WORKFLOWS_FETCH_PAYLOAD_INJECT';

export const WORKFLOWS_CREATE_START = 'WORKFLOWS_CREATE_START';
export const WORKFLOWS_CREATE_API = 'WORKFLOWS_CREATE_API';
export const WORKFLOWS_CREATE_API_PENDING = 'WORKFLOWS_CREATE_API_PENDING';
export const WORKFLOWS_CREATE_API_FULFILLED = 'WORKFLOWS_CREATE_API_FULFILLED';
export const WORKFLOWS_CREATE_API_REJECTED = 'WORKFLOWS_CREATE_API_REJECTED';
export const WORKFLOWS_CREATE_PAYLOAD_INJECT = 'WORKFLOWS_CREATE_PAYLOAD_INJECT';

export const WORKFLOWS_UPDATE_START = 'WORKFLOWS_UPDATE_START';
export const WORKFLOWS_UPDATE_API = 'WORKFLOWS_UPDATE_API';
export const WORKFLOWS_UPDATE_API_PENDING = 'WORKFLOWS_UPDATE_API_PENDING';
export const WORKFLOWS_UPDATE_API_FULFILLED = 'WORKFLOWS_UPDATE_API_FULFILLED';
export const WORKFLOWS_UPDATE_API_REJECTED = 'WORKFLOWS_UPDATE_API_REJECTED';
export const WORKFLOWS_UPDATE_PAYLOAD_INJECT = 'WORKFLOWS_UPDATE_PAYLOAD_INJECT';

export const STATES_UPDATE_START = 'STATES_UPDATE_START';
export const STATES_UPDATE_API = 'STATES_UPDATE_API';
export const STATES_UPDATE_API_PENDING = 'STATES_UPDATE_API_PENDING';
export const STATES_UPDATE_API_FULFILLED = 'STATES_UPDATE_API_FULFILLED';
export const STATES_UPDATE_API_REJECTED = 'STATES_UPDATE_API_REJECTED';
export const STATES_UPDATE_PAYLOAD_INJECT = 'STATES_UPDATE_PAYLOAD_INJECT';

export const fetchWorkflowsAction = () => {
  return {
    type: WORKFLOWS_FETCH_START,
    payload: null,
  };
};

export const createWorkflowAction = (type, attributes) => {
  return {
    type: WORKFLOWS_CREATE_START,
    payload: { type, attributes },
  };
};

export const updateWorkflowAction = (workflow, attributes) => {
  return {
    type: WORKFLOWS_CREATE_START,
    payload: { workflow, attributes },
  };
};

export const updateStateAction = (id, attributes) => {
  return {
    type: STATES_UPDATE_START,
    payload: { id, attributes },
  };
};

